/**
 * Grad firme iz registracije (Company.city) — kvarx lista se uvek seče na taj grad.
 */
export const getCompanyCityFromProfile = (user) => {
  try {
    const fromUser = user?.result?.city;
    if (fromUser) return String(fromUser).trim();

    if (typeof window === 'undefined') return '';
    const profile = JSON.parse(localStorage.getItem('profile') || '{}');
    return String(profile?.result?.city || '').trim();
  } catch {
    return '';
  }
};

export const companyHasKvarxCity = (user) => Boolean(getCompanyCityFromProfile(user));
